import React from 'react';
const stats = [{
  num: '+18K',
  label: 'Docenti che hanno trasformato il loro metodo di insegnamento.'
}, {
  num: '2.300+',
  label: 'Scuole in tutta Italia utilizzano già i nostri materiali.'
}, {
  num: '520K+',
  label: "Attività e laboratori scaricati dall'inizio dell'anno."
}, {
  num: '94%',
  label: 'Riduzione del tempo di preparazione settimanale.'
}];
const standards = ['Progettato per scuola media e superiore italiana', 'Compatibile con tablet, smartphone e stampa', 'Attività pratiche già pronte', 'Sistema progressivo dalla media alla superiore', 'Verifiche e mappe concettuali incluse'];
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-12 sm:py-16 border-y border-border-light px-4 relative overflow-hidden" data-id="element-264">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" data-id="element-265"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-266">
        <p className="text-center text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-8" data-id="element-267">
          La Community Italiana
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-10 sm:mb-12" data-id="element-268">
          {stats.map((stat, i) => <div key={i} className="text-center" data-id="element-269">
              <div className="text-primary font-montserrat font-black text-2xl sm:text-4xl mb-2 drop-shadow-[0_0_8px_rgba(30,142,90,0.3)]" data-id="element-270">
                {stat.num}
              </div>
              <p className="text-text-sec text-xs sm:text-sm leading-snug" data-id="element-271">
                {stat.label}
              </p>
            </div>)}
        </div>

        <div className="border-t border-border-light pt-8 sm:pt-10" data-id="element-272">
          <p className="text-center text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-6" data-id="element-273">
            Uno Standard Professionale Creato per i Docenti Moderni
          </p>
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4" data-id="element-274">
            {standards.map((s, i) => <div key={i} className="flex items-center gap-2 bg-bg-dark border border-primary/20 rounded-full px-4 py-2 shadow-sm" data-id="element-275">
                <span className="text-check-green text-sm font-bold" data-id="element-276">✅</span>
                <p className="text-text-main font-medium text-xs sm:text-sm leading-snug" data-id="element-277">
                  {s}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}